import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Button, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { gettingStartedRoute } from '../../../routes';
import { useAppSelector } from '../../../store/hooks';

interface Props {
    isMenuItem?: boolean;
}

export function NavAccountSetupButton({ isMenuItem }: Props) {
    const history = useHistory();

    const dialerIsEnabled = useAppSelector(state => state.user.dialerIsEnabled);
    const dialerIsSetup = useAppSelector(state => state.user.dialerIsSetup);
    const hasUserEmail = useAppSelector(state => !!state.user.userEmailId);

    const handleClick = () => {
        history.push(gettingStartedRoute);
    };

    //if dialer is enabled and setup, or if user has email, do not show button
    if ((dialerIsEnabled && dialerIsSetup && hasUserEmail) || (!dialerIsEnabled && hasUserEmail)) {
        return null;
    }

    if (isMenuItem) {
        return (
            <MenuItem onClick={handleClick}>
                <ListItemIcon>
                    <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary="Finish Setting Up Your Account" />
            </MenuItem>
        );
    }

    return (
        <Button variant="contained" color="success" onClick={handleClick}>
            Finish Setting Up Your Account
        </Button>
    );
}
